import React from "react";

/**
 * Ícones da nova identidade visual Matera v4.
 * Spec: viewBox 20x20, stroke 2px, linecap/linejoin round, cor herdada via currentColor.
 * Fonte: guia de identidade Matera v4 (seção Ícones).
 */
const IconBase = ({ size = 20, children, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
        {...props}
    >
        {children}
    </svg>
);

export const IconAdicionar = (props) => (
    <IconBase {...props}>
        <line x1="10" y1="3" x2="10" y2="17" />
        <line x1="3" y1="10" x2="17" y2="10" />
    </IconBase>
);

export const IconFechar = (props) => (
    <IconBase {...props}>
        <line x1="4" y1="4" x2="16" y2="16" />
        <line x1="16" y1="4" x2="4" y2="16" />
    </IconBase>
);

export const IconConfirmar = (props) => (
    <IconBase {...props}>
        <polyline points="3,10 8,15 17,5" />
    </IconBase>
);

export const IconAvancar = (props) => (
    <IconBase {...props}>
        <line x1="3" y1="10" x2="17" y2="10" />
        <polyline points="11,4 17,10 11,16" />
    </IconBase>
);

export const IconVoltar = (props) => (
    <IconBase {...props}>
        <line x1="17" y1="10" x2="3" y2="10" />
        <polyline points="9,4 3,10 9,16" />
    </IconBase>
);

export const IconExpandir = (props) => (
    <IconBase {...props}>
        <polyline points="4,7 10,13 16,7" />
    </IconBase>
);

export const IconBuscar = (props) => (
    <IconBase {...props}>
        <circle cx="9" cy="9" r="5.5" />
        <line x1="13.5" y1="13.5" x2="18" y2="18" />
    </IconBase>
);

export const IconUsuario = (props) => (
    <IconBase {...props}>
        <circle cx="10" cy="7" r="3.5" />
        <path d="M3 18c0-3 3.1-5.5 7-5.5s7 2.5 7 5.5" />
    </IconBase>
);

export const IconCalendario = (props) => (
    <IconBase {...props}>
        <rect x="3" y="4" width="14" height="13" rx="2" />
        <line x1="7" y1="2" x2="7" y2="6" />
        <line x1="13" y1="2" x2="13" y2="6" />
        <line x1="3" y1="9" x2="17" y2="9" />
    </IconBase>
);

export const IconDownload = (props) => (
    <IconBase {...props}>
        <line x1="10" y1="3" x2="10" y2="14" />
        <polyline points="5,9 10,14 15,9" />
        <line x1="3" y1="18" x2="17" y2="18" />
    </IconBase>
);

export const IconEditar = (props) => (
    <IconBase {...props}>
        <path d="M14.5 2.5l3 3-9 9H5.5v-3l9-9z" />
    </IconBase>
);

export const IconUpload = (props) => (
    <IconBase {...props}>
        <polyline points="5,8 10,3 15,8" />
        <line x1="10" y1="3" x2="10" y2="15" />
        <line x1="3" y1="18" x2="17" y2="18" />
    </IconBase>
);

export const IconNotificacao = (props) => (
    <IconBase {...props}>
        <path d="M10 2.5a6 6 0 0 1 6 6v3.5l1.5 2.5h-15L4 12V8.5A6 6 0 0 1 10 2.5z" />
        <line x1="8" y1="17.5" x2="12" y2="17.5" />
    </IconBase>
);

export const IconInformacao = (props) => (
    <IconBase {...props}>
        <circle cx="10" cy="10" r="7.5" />
        <line x1="10" y1="6.5" x2="10" y2="10.5" />
        <line x1="10" y1="13.5" x2="10" y2="13.6" />
    </IconBase>
);

export const IconGrafico = (props) => (
    <IconBase {...props}>
        <rect x="3" y="11" width="4" height="6" rx="1" />
        <rect x="8" y="7" width="4" height="10" rx="1" />
        <rect x="13" y="3" width="4" height="14" rx="1" />
    </IconBase>
);

export const IconFiltros = (props) => (
    <IconBase {...props}>
        <line x1="3" y1="6" x2="17" y2="6" />
        <line x1="6" y1="10" x2="14" y2="10" />
        <line x1="9" y1="14" x2="11" y2="14" />
    </IconBase>
);

export const IconMonitor = (props) => (
    <IconBase {...props}>
        <path d="M4 4h12v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4z" />
        <line x1="8" y1="18" x2="12" y2="18" />
        <line x1="10" y1="15" x2="10" y2="18" />
        <line x1="2" y1="4" x2="18" y2="4" />
    </IconBase>
);

export const IconGrid = (props) => (
    <IconBase {...props}>
        <rect x="3" y="3" width="6" height="6" rx="1" />
        <rect x="11" y="3" width="6" height="6" rx="1" />
        <rect x="3" y="11" width="6" height="6" rx="1" />
        <rect x="11" y="11" width="6" height="6" rx="1" />
    </IconBase>
);

export const IconHistorico = (props) => (
    <IconBase {...props}>
        <circle cx="10" cy="10" r="7.5" />
        <polyline points="10,6 10,10 13,12" />
    </IconBase>
);

export const IconExcluir = (props) => (
    <IconBase {...props}>
        <path d="M3 6h14M6 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M8 10v5M12 10v5M4 6l1 11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-11" />
    </IconBase>
);
